var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"ex-header-wrapper"},[_c('div'),_vm._v(" "),_c('div',[_c('button',{staticStyle:{"color":"#c7c5d8"},on:{"click":function($event){return _vm.signOut()}}},[_vm._v("Sign out")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ab01e68","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header/Header.vue
// module id = null
// module chunks = 